module.exports = __webpack_public_path__ + "img/hospital-user-duotone.a0183465.svg";